import React, { useEffect, useState } from 'react';
import { TInfo } from '../../../types';
import Button from '../../global/Button';
import { registerNetcoreActivity } from '../../../utils/registerActivity';
import jwtDecode from 'jwt-decode';
import ReactGA from 'react-ga4';
import { ClipLoader } from 'react-spinners';
import { norebaseUrl } from '../../../utils/constants';
import { checkNamefn } from '../../../utils/checkNameAvailability';
import useDebounce from '../../../hooks/useDebounce';
import { checkedGreen } from '../../../assets/images/dashboard-business';
import styles from '../../../common/dropdown/dropdown.module.css';

type TProps = {
  step1: TInfo;
  setStep1: React.Dispatch<React.SetStateAction<TInfo>>;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  step: number;
};
const BusinessName = ({ setStep, step1, setStep1, step }: TProps) => {
  const [name1, setName1] = useState<any>({});
  const [name2, setName2] = useState<any>({});
  const [name3, setName3] = useState<any>({});
  const [check1, setCheck1] = useState(false);
  const [check2, setCheck2] = useState(false);
  const [check3, setCheck3] = useState(false);
  const [error, setError] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  let nameExists: { [key: string]: string } = {};

  // !-------------- PLEASE READDDDDDDDDDDDDDD -----------------------------------------!  //
  // CHECK1, CHECK2, CHECK3 stand for the states that keep track of whether the name is free,
  // if it's not free, that means it already exists in cac's database already
  // they will have a false value if it's not free, that is, if the name check returns an array of length > 0
  // and true otherwise.

  const debouncedFirstBusinessName = useDebounce(step1.firstbusinessName, 500);
  const debouncedSecondtBusinessName = useDebounce(step1.secondbusinessName, 500);
  const debouncedThirdBusinessName = useDebounce(step1.threebusinessName, 500);
  const displayErrorMsg = (errorText: string, variable: string) => {
    if (submitting && !variable) {
      return <div className='text-[red] text-[11px]'>{errorText}</div>;
    }
  };

  const businessNameIsEmpty = () => {
    return !step1.firstbusinessName || !step1.secondbusinessName || !step1.threebusinessName;
  };

  const businessNameNotFree = () => {
    if (error) {
      return false;
    }
    return !check1 || !check2 || !check3;
  };

  const hasDuplicates = () => {
    const array = [
      step1.firstbusinessName?.trim()?.toLowerCase(),
      step1.secondbusinessName?.trim()?.toLowerCase(),
      step1.threebusinessName?.trim()?.toLowerCase(),
    ];
    const uniqueItems = new Set(array);
    return uniqueItems.size !== array.length;
  };

  const handleNameAlreadyExists = (name: string, key: string) => {
    const formatedName = name?.trim().toLowerCase();
    if (Object.keys(nameExists).includes(formatedName)) {
      if (nameExists[formatedName] !== key) {
        return (
          <div className='text-[red] text-[11px]'>{`${name} has already been used by you`}</div>
        );
      }
    } else {
      nameExists = { ...nameExists, [formatedName]: key };
    }
    return null;
  };

  useEffect(() => {
    if (debouncedFirstBusinessName) {
      checkNamefn(setName1, debouncedFirstBusinessName, setCheck1, setLoading1, setError);
    } else {
      setCheck1(false);
      setName1([]);
    }
  }, [debouncedFirstBusinessName]);

  useEffect(() => {
    if (debouncedSecondtBusinessName) {
      checkNamefn(setName2, debouncedSecondtBusinessName, setCheck2, setLoading2, setError);
    } else {
      setCheck2(false);
      setName2([]);
    }
  }, [debouncedSecondtBusinessName]);

  useEffect(() => {
    if (debouncedThirdBusinessName) {
      checkNamefn(setName3, debouncedThirdBusinessName, setCheck3, setLoading3, setError);
    } else {
      setCheck3(false);
      setName3([]);
    }
  }, [debouncedThirdBusinessName]);

  return (
    <div className='flex justify-center w-full  lg:w-[700px] mx-auto'>
      <form className=' stepTwo formCont w-full'>
        <div className='w-full'>
          <div className='mb-[27px] relative'>
            <>
              <label className='flex flex-col relative text-[#212121] '>Business name 1</label>
              <input
                className='w-full h-[52px] border-[1px] relative border-[#B8C9C9] rounded-[2px] focus:border-[#F8B400] outline-none px-[10px] md:px-[16px] rounded-[4px]'
                value={step1.firstbusinessName}
                onChange={(e) => {
                  setStep1({ ...step1, firstbusinessName: e.target.value });
                }}
              />

              {loading1 && (
                <ClipLoader
                  color={'#F8B400'}
                  loading={loading1}
                  size={20}
                  className='absolute right-[10px] h-[20px] top-[50%]'
                />
              )}
              {check1 &&
                !handleNameAlreadyExists(step1.firstbusinessName, 'Name1') &&
                !loading1 && (
                  <img
                    src={checkedGreen}
                    alt=''
                    className='absolute right-[10px] h-[20px] top-[50%]'
                  />
                )}
              {name1?.result?.length > 0 && !loading1 && (
                <div className={styles.dropdownMenu_businessName}>
                  <div className='text-[red] text-sm font-[500] h-[40px] flex items-center'>
                    THESE NAME(S) ALREADY EXIST, HENCE NONE OF THEM CAN BE USED
                  </div>
                  <hr className='w-[90%]' />
                  {name1?.result?.map((option: any, i: number) => (
                    <div key={i} className={styles.dropdownItem_businessName}>
                      {option?.data?.companyName}
                    </div>
                  ))}
                </div>
              )}
            </>
            {handleNameAlreadyExists(step1.firstbusinessName, 'Name1')}
            {displayErrorMsg('Business name 1 cannot be empty', step1.firstbusinessName)}
          </div>
          <div className='mb-[27px] relative'>
            <>
              <label className='flex flex-col relative text-[#212121] '>Business name 2</label>
              <input
                className='w-full h-[52px] px-[10px] md:px-[16px] rounded-[4px] border-[1px] relative border-[#B8C9C9] rounded-[2px] focus:border-[#F8B400] outline-none '
                value={step1.secondbusinessName}
                onChange={(e) => {
                  setStep1({ ...step1, secondbusinessName: e.target.value });
                }}
              />
              {loading2 && (
                <ClipLoader
                  color={'#F8B400'}
                  loading={loading2}
                  size={20}
                  className='absolute right-[10px] h-[20px] top-[50%]'
                />
              )}
              {check2 &&
                !handleNameAlreadyExists(step1.secondbusinessName, 'Name2') &&
                !loading2 && (
                  <img
                    src={checkedGreen}
                    alt=''
                    className='absolute right-[10px] h-[20px] top-[50%]'
                  />
                )}
              {name2?.result?.length > 0 && !loading2 && (
                <div className={styles.dropdownMenu_businessName}>
                  <div className='text-[red] text-sm font-[500] h-[40px] flex items-center'>
                    THESE NAME(S) ALREADY EXIST, HENCE NONE OF THEM CAN BE USED
                  </div>
                  <hr className='w-[90%]' />
                  {name2?.result?.map((option: any, i: number) => (
                    <div key={i} className={styles.dropdownItem_businessName}>
                      {option?.data?.companyName}
                    </div>
                  ))}
                </div>
              )}
            </>
            {handleNameAlreadyExists(step1.secondbusinessName, 'Name2')}
            {displayErrorMsg('Business name 2 cannot be empty', step1.secondbusinessName)}
          </div>
          <div className='mb-[27px] relative'>
            <>
              <label className='flex flex-col relative text-[#212121] '>Business name 3</label>
              <input
                className='w-full h-[52px] px-[10px] md:px-[16px] rounded-[4px] relative border-[1px] border-[#B8C9C9] rounded-[2px] focus:border-[#F8B400] outline-none '
                value={step1.threebusinessName}
                onChange={(e) => {
                  setStep1({ ...step1, threebusinessName: e.target.value });
                }}
              />
              {loading3 && (
                <ClipLoader
                  color={'#F8B400'}
                  loading={loading3}
                  size={20}
                  className='absolute right-[10px] h-[20px] top-[50%]'
                />
              )}
              {check3 &&
                !handleNameAlreadyExists(step1.threebusinessName, 'Name3') &&
                !loading3 && (
                  <img
                    src={checkedGreen}
                    alt=''
                    className='absolute right-[10px] h-[20px] top-[50%]'
                  />
                )}
              {name3?.result?.length > 0 && !loading3 && (
                <div className={styles.dropdownMenu_businessName}>
                  <div className='text-[red] text-sm font-[500] h-[40px] flex items-center'>
                    THESE NAME(S) ALREADY EXIST, HENCE NONE OF THEM CAN BE USED
                  </div>
                  <hr className='w-[90%]' />
                  {name3?.result?.map((option: any, i: number) => (
                    <div key={i} className={styles.dropdownItem_businessName}>
                      {option?.data?.companyName}
                    </div>
                  ))}
                </div>
              )}
            </>
            {handleNameAlreadyExists(step1.threebusinessName, 'Name3')}
            {displayErrorMsg('Business name 3 cannot be empty', step1.threebusinessName)}
          </div>
          <div className='flex justify-between  mt-[40px] mb-7 md:mb-0 items-center md:mt-[105px]'>
            <Button
              className='px-[20px] h-[40px] text-[11px] !bg-[#768396] text-white border-[0px] !rounded-[6px] '
              size='sm'
              underline={false}
              theme='secondary'
              onClick={() => {
                setStep((currPage: any) => currPage - 1);
              }}
            >
              PREVIOUS
            </Button>
            <Button
              theme='primary'
              className='px-[20px] h-[40px] !rounded-[6px] text-[11px] inline-block '
              size='sm'
              underline={false}
              onClick={() => {
                if (!businessNameIsEmpty() && !hasDuplicates() && !businessNameNotFree()) {
                  setStep((currPage: any) => currPage + 1);
                }
                setSubmitting(true);
              }}
            >
              SAVE AND CONTINUE
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default BusinessName;
